import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { isEmpty } from 'lodash'
import { useSelector } from 'react-redux'

import RefundComponent from 'components/RefundComponent'

import { fetchOrder } from 'utils/api'
import {
  getIsAllOrdersLoading,
  getIsLoadingRefundOrders,
} from 'store/Orders/selector'

const Refund = () => {
  const [order, setOrder] = useState({})
  const { uuid } = useParams()

  const isLoadingRefundOrders = useSelector(getIsLoadingRefundOrders)
  const isLoadingAllOrders = useSelector(getIsAllOrdersLoading)

  useEffect(() => {
    fetchOrder(uuid)?.then((res) => setOrder(res?.data))
  }, [uuid])

  const isLoading =
    isLoadingRefundOrders || isEmpty(order) || isLoadingAllOrders

  return <RefundComponent order={order} isLoading={isLoading} />
}

export default Refund
